import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex)
//let DOMAIN_PREFIX='https://document.miansha2020.com'
//let DOMAIN_PREFIX='https://'+window.location.hostname
export default new Vuex.Store({
    state: {
        baseUrl:'',
        sum: 0,
        school:"",
        subject:"",
        loginModel:false,
        loginType:3,
        token:'',
        userInfo:{},
        payStatus:false,
        payId:'',
        baseInfo:{}
    },
    mutations: {
        setLogin(state, value) {
            state.loginModel = value
        },
        setLoginType(state, value) {
            state.loginType = value
        },
        setToken(state,value){
            state.token=value
        },
        setUserInfo(state,value){
            state.userInfo=value
        },
        setPay(state,value){
            state.payStatus=value
        },
        setPayId(state,value){
            state.payId=value
        },
        setConfig(state,value){
            state.baseInfo=value
        },
        setUrl(state,value){
            state.baseUrl=value
        }
    },
    plugins: [createPersistedState()]
})
